import { Controller } from "@hotwired/stimulus"

// Satisfaction Rating Controller
// Provides visual star rating with labels
export default class extends Controller {
  static targets = ["star", "label", "hiddenField"]
  static values = {
    rating: { type: Number, default: 0 }
  }

  static labels = [
    "", // 0 - no selection
    "Very Dissatisfied",
    "Dissatisfied",
    "Neutral",
    "Satisfied",
    "Very Satisfied"
  ]

  connect() {
    this.updateDisplay()
  }

  select(event) {
    const rating = parseInt(event.currentTarget.dataset.rating, 10)

    // Toggle off if clicking same rating
    if (this.ratingValue === rating) {
      this.ratingValue = 0
    } else {
      this.ratingValue = rating
    }

    this.updateDisplay()
    this.updateHiddenField()
  }

  hover(event) {
    const rating = parseInt(event.currentTarget.dataset.rating, 10)
    this.highlightStars(rating)
    this.showLabel(rating)
  }

  leave() {
    this.updateDisplay()
  }

  highlightStars(upTo) {
    this.starTargets.forEach((star, index) => {
      const starRating = index + 1
      if (starRating <= upTo) {
        star.classList.remove("far")
        star.classList.add("fas")
        star.classList.add("text-warning")
      } else {
        star.classList.add("far")
        star.classList.remove("fas")
        star.classList.remove("text-warning")
      }
    })
  }

  showLabel(rating) {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.constructor.labels[rating] || ""
    }
  }

  updateDisplay() {
    this.highlightStars(this.ratingValue)
    this.showLabel(this.ratingValue)
  }

  updateHiddenField() {
    if (this.hasHiddenFieldTarget) {
      this.hiddenFieldTarget.value = this.ratingValue > 0 ? this.ratingValue : ""
    }
  }
}
